<template>
    <div>
        <el-form label-width="120px" :label-position="labelPosition" size="small">
            <el-tabs v-model="activeName" plane>
                <el-tab-pane label="Hadisə Təhvil/Təslim" name="handover">

                    <div>
                        <el-button size="small" v-if="[2, 3, 4].includes(this.referral.status)" style="margin-bottom: 10px"
                            type="primary" @click="openFileModal">Fayl
                            Yüklə</el-button>
                        <div v-if="this.referral">
                            <br>
                            <card>
                                <div class="row align-items-center">
                                    <div class="col-7">
                                        <titles text="Göndəriş"></titles>
                                    </div>
                                    <div class="col-5 d-flex justify-content-end">
                                        <referral-status :status="referral.status" :statusName="referral.statusname"
                                            tag="span" />
                                    </div>
                                </div>

                                <hr width="100%" size="50"
                                    style="margin-top: 5px; position: relative;height: 1px;background: #F3EFE0;"
                                    align="center">

                                <div class="row">
                                    <div :class="['col-2 ', textLeft, ' pd']">Tarix</div>
                                    <div class="col-4 pd">{{ this.referral.referraldatestr }}</div>
                                    <div :class="['col-2 ', textLeft, ' pd']">Təmir mərkəzi</div>
                                    <div class="col-4 pd">{{ this.referral.centername }}</div>
                                </div>

                                <div class="row">
                                    <div :class="['col-2 ', textLeft, ' pd']">Məsul şəxs</div>
                                    <div class="col-4 pd">{{ this.referral.respperson }}</div>
                                    <div :class="['col-2 ', textLeft, ' pd']">Mobil nömrə</div>
                                    <div class="col-4 pd">{{ this.referral.resppersonphone }}</div>

                                </div>

                                <div class="row">
                                    <div :class="['col-2 ', textLeft, ' pd']">Masul şəxs email</div>
                                    <div class="col-4 pd">{{ this.referral.resppersonemail }}</div>
                                    <div :class="['col-2 ', textLeft, ' pd']">Link</div>
                                    <div class="col-4 pd" v-if="this.referralData.publiclink">
                                        <a :href="this.referralData.publiclink" target="_blank"
                                            style="color: #007bff; text-decoration: none; position: relative; top: -4px;">
                                            {{ this.referralData.publiclink }}
                                        </a>
                                        <span
                                            style="margin-left: 8px; display: inline-flex; align-items: center; position: relative; top: -4px;">
                                            <span
                                                style="background-color: #f5f5f5; padding: 4px 8px; border: 1px solid #ddd; border-radius: 4px; display: inline-flex; align-items: center; cursor: pointer;">
                                                <i class="el-icon-view" style=" font-size: var(--font-large); margin-right: 4px;"></i>
                                                <span>{{ this.referralData.viewCount || 0 }}</span>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <br>

                                <titles text="Nəqliyyat vasitəsi"></titles>
                                <hr width="100%" size="50"
                                    style="margin-top: 5px; position: relative;height: 1px;background: #F3EFE0;"
                                    align="center">

                                <div class="row">
                                    <div :class="['col-2 ', textLeft, ' pd']">Marka model</div>
                                    <div class="col-4 pd">{{ this.referral.carname }}</div>
                                    <div :class="['col-2 ', textLeft, ' pd']">Qeydiyyat nişanı</div>
                                    <div class="col-4 pd">{{ this.referral.regnumber }}</div>
                                </div>

                                <div class="row">
                                    <div :class="['col-2 ', textLeft, ' pd']">Buraxılış ili</div>
                                    <div class="col-4 pd">{{ this.referral.production }}</div>
                                    <div :class="['col-2 ', textLeft, ' pd']">Cari yürüş</div>
                                    <div class="col-4 pd">{{ this.referral.mileage }}</div>
                                </div>

                                <div class="row">
                                    <div :class="['col-2 ', textLeft, ' pd']">Mühərrikin həcmi (cm³)</div>
                                    <div class="col-4 pd">{{ this.referral.engine }}</div>
                                    <div :class="['col-2 ', textLeft, ' pd']">VIN</div>
                                    <div class="col-4 pd">{{ this.referral.vin }}</div>
                                </div>

                                <br>

                                <titles text="Müştəri"></titles>
                                <hr width="100%" size="50"
                                    style="margin-top: 5px; position: relative;height: 1px;background: #F3EFE0;"
                                    align="center">

                                <div class="row">
                                    <div :class="['col-2 ', textLeft, ' pd']">Müştərinin adı</div>
                                    <div class="col-4 pd">{{ this.referral.clientname }}</div>

                                    <div :class="['col-2 ', textLeft, ' pd']">Mobil nömrə</div>
                                    <div style="margin-top: -4px;" class="col-4 pd">
                                        {{ this.referral.clientphone }}
                                        <el-button  type="info" icon="el-icon-message" size="mini" plain class="ml-2"
                                            @click="beforeSendSms">
                                        </el-button>
                                        <span
                                            :style="{ color: referral.smssent ? 'green' : 'red', fontSize: '10px', fontWeight: 'bold', marginLeft: '8px' }">
                                            {{
                                            referral.smssent
                                            ? "SMS göndərilib: " + referral.smssent
                                            : "SMS göndərilməyib"
                                            }}
                                        </span>
                                    </div>
                                </div>

                                <div class="row">
                                    <div :class="['col-2 ', textLeft, ' pd']">Email</div>
                                    <div class="col-4 pd">{{ this.referral.clientemail || 'Email yoxdur' }}</div>
                                    <div :class="['col-2 ', textLeft, ' pd']">Hadisə/SS nömrəsi</div>
                                    <div class="col-4 pd">{{ this.referral.policynumber }}</div>
                                </div>
                            </card>
                        </div>

                        <card>


                            <titles text="Təhvİl"></titles>
                            <hr width="100%" size="50"
                                style="margin-top: 5px; position: relative;height: 1px;background: #F3EFE0;"
                                align="center"> <stage-image :images="uploadedFiles('1', referral.id)" />
                        </card>
                        <div style="margin-top: 20px; margin-bottom: 20px;"></div>
                        <card>
                            <titles text="Təslİm"></titles>
                            <hr width="100%" size="50"
                                style="margin-top: 5px; position: relative;height: 1px;background: #F3EFE0;"
                                align="center">
                            <stage-image :images="uploadedFiles('2', referral.id)" />
                        </card>
                    </div>
                </el-tab-pane>

                <el-tab-pane name="offer" label="Təkliflər">
                    <div>
                        <el-table v-if="offerData.length > 0" :data="offerData" :border="false" style="width: 100%">
                            <el-table-column prop="offernumberstr" label="#" width="150"></el-table-column>
                            <el-table-column prop="offerdatestr" :label="$t('Tarix')" width="200"></el-table-column>
                            <el-table-column prop="duration" label="Təmirin müddəti, qeydlər" width="300">
                                <template slot-scope="scope">
                                    {{ scope.row.duration }} gün, {{ scope.row.notes }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="statusname" :label="$t('Status')" width="200">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.statusname === 'Təsdiq'" style="color: green;">
                                        <i class="el-icon-circle-check"></i> {{ scope.row.statusname }}
                                    </span>
                                    <span v-else-if="scope.row.statusname === 'İmtina'" style="color: red;">
                                        <i class="el-icon-circle-close"></i> {{ scope.row.statusname }}
                                    </span>
                                    <span v-else style="color: orange;">
                                        <i class="el-icon-warning"></i> {{ scope.row.statusname }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="statusdatestr" label="Statusun tarixi, qeydlər">
                                <template slot-scope="scope">
                                    {{ scope.row.statusdatestr }}, {{ scope.row.statusnotes }}
                                </template>
                            </el-table-column>
                            <el-table-column align="center" fixed="right" width="100">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="small" @click="verifyAction(scope.row)">
                                        <i class="el-icon-circle-check"></i> Qərar
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>

                        <div v-else>
                            <p>Təklif tapılmadı.</p>
                        </div>
                        <el-dialog :visible.sync="isModalVisible" title="Təklifin təsdiqi" width="500px">
                            <el-form ref="offerForm" :model="modalData" label-width="200px"
                                :label-position="labelPosition" :rules="offerRules">
                                <el-form-item label="Razılaşdırılmış məbləğ" prop="agreedAmount">
                                    <el-input v-model.number="modalData.agreedAmount" type="number"
                                        placeholder="Məbləğ daxil edin"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('Qeydlər')">
                                    <el-input type="textarea" :rows="6" v-model="modalData.notes"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('Status')" prop="status">
                                    <el-select v-model="modalData.status" placeholder="Status seçin"
                                        style="width: 100%">
                                        <el-option :label="$t('Təsdiq')" :value="1"></el-option>
                                        <el-option label="İmtina" :value="2"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form>

                            <div style="margin-top: 20px;">
                                <p>Fayllar:</p>
                                <div v-if="uploadedFiles('3', this.modalData.id).length > 0">
                                    <ul style="list-style: none; padding: 0;">
                                        <li v-for="(file, index) in uploadedFiles('3', this.modalData.id)" :key="index">
                                            <a :href="file.url" target="_blank">{{ file.filename }}</a>
                                        </li>
                                    </ul>
                                </div>
                                <p v-else>Fayl tapılmadı.</p>
                            </div>

                            <span slot="footer" class="dialog-footer" style="text-align: right">
                            <el-button size="small" type="primary" v-if="[2, 3, 4].includes(this.referral.status)"
                                    @click="validateAndSave">Yadda
                                    Saxla</el-button>
                                <el-button size="small" @click="isModalVisible = false">İmtina</el-button>
                                
                            </span>
                        </el-dialog>

                    </div>
                </el-tab-pane>

                <el-tab-pane name="repairstage" label="Təmir mərhələləri">
                    <div>
                        <card v-if="stages.length > 0">
                            <div class="row">
                                <div class="col-12">
                                    <titles text="Təmir məlumatları"></titles>
                                    <hr width="100%" size="50"
                                        style="margin-top: 5px; position: relative;height: 1px;background: #F3EFE0;"
                                        align="center">
                                </div>
                            </div>

                            <div class="row" style="padding-top: 15px;">
                                <div :class="['col-2 ', textLeft, ' pd']">Bitmə tarixi</div>
                                <div class="col-4 pd">{{ this.repair.duedatestr }}</div>


                                <div :class="['col-2 ', textLeft, ' pd']"></div>
                                <div class="col-4 pd"></div>

                            </div>

                            <div class="row" style="padding-top: 15px;">

                                <div :class="['col-2 ', textLeft, ' pd']">{{$t('Düzəliş')}} olunmuş bitmə tarixi</div>
                                <div class="col-4 pd">{{ this.repair.duedateupdatestr || ' - ' }}</div>

                                <div :class="['col-2 ', textLeft, ' pd']">Səbəb</div>
                                <div class="col-4 pd">{{ this.repair.duedateupdatereasonname || ' - ' }}</div>


                            </div>
                            <div class="row" style="padding-top: 15px;">

                                <div :class="['col-2 ', textLeft, ' pd']">Faktiki bitmə tarixi</div>
                                <div class="col-4 pd">{{ this.repair.finishdatestr || ' - ' }}</div>

                                <div :class="['col-2 ', textLeft, ' pd']">Qeydlər</div>
                                <div class="col-4 pd">{{ this.repair.finishnotes || ' - ' }}</div>


                            </div>

                            <div class="row" style="padding-top: 15px;">

                                <div :class="['col-2 ', textLeft, ' pd']">Təslim alınma tarixi</div>
                                <div class="col-4 pd">{{ this.repair.acceptdatestr }}</div>

                                <div :class="['col-2 ', textLeft, ' pd']">Qeydlər</div>
                                <div class="col-4 pd">{{ this.repair.acceptnotes || ' - ' }}</div>

                            </div>
                        </card>

                        <card v-if="stages.length > 0">
                            <el-row :gutter="20">
                                <el-col :span="24" v-for="item in stages" :key="item.id" style="margin-bottom: 20px;">
                                    <div class="stage-item">
                                        <titles :text="item.stagename"></titles>
                                        <hr width="100%" size="50"
                                            style="margin-top: 5px; position: relative; height: 1px; background: #F3EFE0;"
                                            align="center">
                                        <stage-image :images="uploadedFiles('4', item.id)" />
                                    </div>
                                </el-col>
                            </el-row>
                        </card>

                        <div v-else>
                            <p>Mərhələ tapılmadı.</p>
                        </div>
                    </div>
                </el-tab-pane>

                <el-tab-pane name="approveAct" label="Yekun akt və təsdiq">
                    <div>
                        <el-button size="small" type="success" v-if="this.referral.status === 7" @click="handleApprove"><i></i>
                            Təsdiq</el-button>
                        <el-button size="small" type="danger" v-if="this.referral.status < 7 && this.referral.status !== 2"
                            @click="handleReject">
                            <i></i> Xitam
                        </el-button>
                    </div>

                    <div v-if="actData && actData.length > 0">
                        <br
                            v-if="this.referral.status === 7 || (this.referral.status < 7 && this.referral.status !== 2)">
                        <card v-for="(item, index) in actData" :key="index">
                            <titles text="Yekun akt məlumatları"></titles>
                            <hr width="100%" size="50"
                                style="margin-top: 5px; position: relative;height: 1px;background: #F3EFE0;"
                                align="center">
                            <div class="row">
                                <div :class="['col-2 ', textLeft, ' pd']">Tarix</div>
                                <div class="col-4 pd">{{ new Date(item.actdate).toLocaleDateString("az-AZ") }}</div>
                                <div :class="['col-2 ', textLeft, ' pd']">Status</div>
                                <div class="col-4 pd">
                                    <span :class="item.actstatus === 1 ? 'status-true' : 'status-false'">
                                        <i v-if="item.actstatus === 1" class="el-icon-circle-check"
                                            style="color: green;"></i>
                                        <i v-else class="el-icon-circle-close" style="color: red;"></i>
                                        {{ item.actstatus === 1 ? "İlkin akta eynidir" : "İlkin akta eyni deyil" }}
                                    </span>
                                </div>
                            </div>
                            <div class="row" style="padding-top: 10px">
                                <div class="col-6">
                                    <div class="row">
                                        <div :class="['col-4 ', textLeft, ' pd']">Akt Məbləği</div>
                                        <div class="col-8 pd">{{ item.actsum }} AZN</div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="row">
                                        <div :class="['col-4 ', textLeft, ' pd']">Qeydlər</div>
                                        <div class="col-8 pd">{{ item.actnotes }}</div>
                                    </div>
                                </div>
                            </div>
                            <div style="margin-top: 20px;">
                                <div class="col-12" style="margin-top: 15px;margin-left: -15px;">
                                    <titles text="Fayllar"></titles>
                                    <hr width="100%" size="50"
                                        style="margin-top: 5px; position: relative;height: 1px;background: #F3EFE0;"
                                        align="center">
                                </div>
                                <div style=" font-size: var(--font-primary);" v-if="uploadedFiles('6', referral.id).length > 0">
                                    <ul style="list-style: none; padding: 0;">
                                        <li v-for="(file, index) in uploadedFiles('6', referral.id)" :key="index">
                                            <a :href="file.url" target="_blank">{{ file.filename }}</a>
                                        </li>
                                    </ul>
                                </div>
                                <p v-else>Fayl tapılmadı.</p>
                            </div>
                        </card>
                    </div>


                    <div v-else>
                        <p>Yekun akt məlumatı tapılmadı.</p>
                    </div>

                </el-tab-pane>
            </el-tabs>
        </el-form>
        <file-selection-modal :loading="careploading" :files="fileSelectionData" :selectedFiles.sync="selectedFiles"
            :openFileSelectionModal.sync="openFileSelectionModal" :selectedImage.sync="selectedImage"
            :imageModalVisible.sync="imageModalVisible" @publish="handlePublish" @show-image="showImage" />
    </div>
</template>
<script>
    import Titles from "../components/Titles.vue";
    import { GetApiToken, GetOffer, UpdateOfferStatus, GetFinalActDetails, ConfirmReferral, RejectReferral, UploadReferralFiles, PublishReferral, GetClaimReferralsById, GetCarepReferral } from "../../services/carep";
    import { GetFilesPublic, GetReferral, GetRepairStages, GetRepair } from "../../services/careppublic";
    import StageImage from "../components/StageImage.vue";
    import FileSelectionModal from "../components/FileSelectionModal.vue";
    import { GetFiles } from "../../services/files";
    import ReferralStatus from "../components/ReferralStatus.vue";
    import { labelPosition,textLeft } from "../../services/helper";

    export default {
        props: {
            id: [String, Number],
        },
        components: {
            Titles,
            StageImage,
            FileSelectionModal,
            ReferralStatus
        },
        data() {
            return {
                activeName: "handover",
                isModalVisible: false,
                modalData: {},
                offerData: [],
                actData: {},
                referral: {},
                files: [],
                stages: [],
                FileSelectionModal,
                openFileSelectionModal: false,
                selectedFiles: [],
                selectedImage: '',
                imageModalVisible: false,
                fileSelectionData: [],
                careploading: false,
                accidentCommId: null,
                referralData: {},
                linkId: null,
                offerRules: {
                    agreedAmount: [
                        { required: true, message: 'Mütləq sahə', trigger: 'blur' }
                    ],
                    status: [
                        { required: true, message: 'Mütləq sahə', trigger: 'change' }
                    ]
                },
                repair: {},
                labelPosition: labelPosition,
                textLeft: textLeft,

            };
        },

        methods: {
            validateAndSave() {
                this.$refs.offerForm.validate(async (valid) => {
                    if (valid) {
                        await this.saveData();
                    } else {
                        this.$message.error("Mütləq sahələri doldurun");
                    }
                });
            },
            verifyAction(row) {
                this.modalData.id = row.id;
                this.isModalVisible = true;
            },
            async saveData() {
                try {
                    this.careploading = true;

                    const tokenResponse = await GetApiToken();
                    const jwtToken = tokenResponse.result.jwt;

                    const payload = {
                        id: this.modalData.id,
                        status: this.modalData.status,
                        statusnotes: this.modalData.notes,
                        offersum: this.modalData.agreedAmount
                    };

                    await UpdateOfferStatus(payload, jwtToken);
                    this.isModalVisible = false;
                    this.$message.success("Uğurlu əməliyyat");

                    const offerResponse = await GetOffer(this.id, jwtToken);
                    if (offerResponse && offerResponse.result) {
                        this.offerData = offerResponse.result;
                    }
                } catch (error) {
                    console.error("Error updating status:", error);
                    this.$message.error("Failed to update status.");
                } finally {
                    this.careploading = false;
                }
            }
            ,
            async getReferral() {
                const response = await GetReferral(this.linkId);
                if (response.data.result) {
                    this.referral = response.data.result;
                }
            },
            async getFiles() {
                const response = await GetFilesPublic(this.linkId);

                if (response.data.result) {
                    this.files = response.data.result.map(item => ({
                        ...item,
                        url: `${this.referral.fileurl}${item.year}/${item.filename}`,
                        thumburl: `${this.referral.fileurl}${item.year}/thumb_${item.filename}`
                    }));
                }
            },
            async getStages() {
                const response = await GetRepairStages(this.linkId);
                if (response.data.result) {
                    this.stages = response.data.result;
                }
            },
            async getRepair() {
                try {
                    const response = await GetRepair(this.linkId);
                    if (response.data && response.data.result) {
                        this.repair = { ...response.data.result };
                    } else {
                        console.warn("No data available.");
                    }
                } catch (error) {
                    console.error("An error occurred:", error);
                }
            },

            uploadedFiles(tp, id) {
                return this.files.filter(
                    (file) => file.sourcetype === tp && file.sourceId === id
                );
            },
            async handleApprove() {
                this.$confirm("Göndəriş təsdiqlənsin?", "Təsdiqləyin", {
                    confirmButtonText: this.$t('Bəli'),
                    cancelButtonText: this.$t('Xeyr'),
                    type: "info",
                }).then(async () => {
                    try {
                        const tokenResponse = await GetApiToken();
                        const jwtToken = tokenResponse.result.jwt;

                        const payload = {
                            id: this.id,
                            notes: '',
                        };

                        await ConfirmReferral(payload, jwtToken);
                        this.$message.success("Uğurlu əməliyyat");

                        const referralResponse = await GetCarepReferral(this.id, jwtToken);
                        if (referralResponse && referralResponse.result) {
                            this.referral = referralResponse.result;
                        }

                    } catch (error) {
                        console.error("Error updating status:", error);
                        this.$message.error("Failed to update status.");
                    }
                }).catch(() => {
                    this.$message.info("Əməliyyat ləğv edildi");
                });
            }
            ,
            async handleReject() {
                this.$confirm("Göndəriş xitam olunsun?", "Təsdiqləyin", {
                    confirmButtonText: this.$t('Bəli'),
                    cancelButtonText: this.$t('Xeyr'),
                    type: "warning",
                }).then(async () => {
                    try {
                        const tokenResponse = await GetApiToken();
                        const jwtToken = tokenResponse.result.jwt;

                        const payload = {
                            id: this.id,
                        };

                        await RejectReferral(payload, jwtToken);
                        this.$message.success("Uğurlu əməliyyat");

                        const referralResponse = await GetCarepReferral(this.id, jwtToken);
                        if (referralResponse && referralResponse.result) {
                            this.referral = referralResponse.result;
                        }

                    } catch (error) {
                        console.error("Error updating status:", error);
                        this.$message.error("Failed to update status.");
                    }
                }).catch(() => {
                    this.$message.info("Əməliyyat ləğv edildi");
                });
            }
            ,
            async initializeData() {
                try {
                    const tokenResponse = await GetApiToken();
                    const jwtToken = tokenResponse.result.jwt;
                    const rid = this.id;

                    const referralDataResponse = await GetCarepReferral(rid, jwtToken);

                    if (referralDataResponse && typeof referralDataResponse.result === 'object') {
                        this.referralData = referralDataResponse.result;
                        this.linkId = this.referralData.publiclink.split('/').pop();
                    } else {
                        console.warn("Response result is not an object or is undefined.");
                        return;
                    }

                    const [offerResponse, actResponse, referralResponse, filesResponse, stagesResponse, repairResponse] = await Promise.all([
                        GetOffer(rid, jwtToken),
                        GetFinalActDetails(rid, jwtToken),
                        this.getReferral(),
                        this.getFiles(),
                        this.getStages(),
                        this.getRepair(),

                    ]);

                    if (offerResponse && offerResponse.result) {
                        this.offerData = JSON.parse(JSON.stringify(offerResponse.result));
                    }
                    if (actResponse && Array.isArray(actResponse.result)) {
                        this.actData = actResponse.result;
                    }

                } catch (error) {
                    console.error("Initialization error:", error);
                }
            },


            async openFileModal() {
                if (this.id) {
                    this.openFileSelectionModal = true;
                    try {
                        this.accidentCommId = this.referrals.length > 0 ? this.referrals[0].accidentCommId : null;
                        const fileData = await GetFiles(1, this.accidentCommId);
                        this.fileSelectionData = fileData.map(file => ({
                            id: file.id,
                            fileName: file.fileName,
                            url: file.url
                        }));
                    } catch (error) {
                        console.error("An error occurred while fetching the files:", error);
                        this.$message.error("An error occurred while loading the files.");
                    }
                } else {
                    this.$message.warning("No valid referralId provided.");
                }

            },
            async handlePublish() {
                try {
                    this.careploading = true;
                    const tokenResponse = await GetApiToken();
                    this.$store.commit("SET_CAREP_JWT", tokenResponse.result.jwt);
                    const jwtToken = this.$store.state.carepJwt;

                    await UploadReferralFiles(this.selectedFiles, this.id, jwtToken);

                    await PublishReferral(this.id, jwtToken);

                    this.$message.success("Uğurlu əməliyyat");

                    await this.getFiles();

                    this.openFileSelectionModal = false;
                } catch (error) {
                    console.error("Səhv əməliyyat:", error);
                    this.$message.error("Yükləmə prosesi uğursuz oldu.");
                } finally {
                    this.careploading = false;
                }
            },
            showImage(url) {
                this.selectedImage = url;
                this.imageModalVisible = true;
            },
            getClaimReferrals() {
                if (this.id) {
                    GetClaimReferralsById(0, this.id)
                        .then(response => {
                            this.referrals = Array.isArray(response.data) ? response.data : [];
                        })
                        .catch(error => {
                            this.$message.error('Error loading referrals data');
                        });
                } else {
                    console.warn(" ID not found");
                }
            },
            async beforeSendSms() {
                this.$confirm(
                    `
        <p>Telefon: <b>${this.referral.clientphone}</b></p>
        <p>${this.referral.carname} ${this.referral.regnumber}</p>
        <p>${this.referral.clientname}</p>
        <p><a href="${this.referralData.publiclink}" target="_blank">${this.referralData.publiclink}</a></p>
        `,
                    "SMS göndərilsin?",
                    {
                        confirmButtonText: this.$t('Bəli'),
                        cancelButtonText: this.$t('Xeyr'),
                        type: "info",
                        dangerouslyUseHTMLString: true
                    }
                ).then(async () => {
                    try {
                        const response = await SendSms(
                            1,
                            this.referral.orgname,
                            this.referral.clientname,
                            this.referral.regnumber,
                            this.referral.clientphone,
                            this.referral.publiclink
                        );

                        if (response.data.Status === 1) {
                            let sms = {
                                sourceid: this.referral.id,
                                sourcetype: 1,
                                uid: this.$store.state.user.id,
                                taskid: response.data.TaskId,
                            };

                            const smsResponse = await SmsSent(sms);
                            if (smsResponse.data.result) {
                                this.$message.success("SMS uğurla göndərildi!");
                                this.referral.smssent = DateTimeToString(new Date());
                            } else {
                                this.$message.error("Əməliyyat uğursuz oldu.");
                            }
                        } else {
                            this.$message.error("Əməliyyat uğursuz oldu.");
                        }
                    } catch (error) {
                        console.error("Error sending SMS:", error);
                        this.$message.error("Failed to send SMS.");
                    }
                }).catch(() => {
                    this.$message.info("Əməliyyat ləğv edildi");
                });
            }

        },
        async mounted() {
            try {
                this.getClaimReferrals();
                await this.initializeData();
            } catch (error) {
                console.error("Initialization error:", error);
            }
        },
        computed: {
            statusText() {
                return this.item.actstatus === 1 ? "İlkin akta eynidir" : "İlkin akta eyni deyil";
            },
            statusClass() {
                return this.item.actstatus === 1 ? "status-true" : "status-false";
            },
            formattedDate() {
                return new Date(this.item.actdate).toLocaleDateString("az-AZ", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                });
            }
        }
    };

</script>
<style scoped>
    .pd {
        padding-top: 5px;
        padding-bottom: 5px;
      font-size: var(--font-primary);
    }

    .red-bold {
        color: red;
        font-weight: bold;
    }

    .status-true,
    .status-false {
       font-size: var(--font-primary);
    }

    .act-card {
        margin-bottom: 20px;
    }

    .status-false {
        color: red;
    }

    .tab-card {
        margin-bottom: 20px;
        padding: 20px;
    }

    .card-header {
        display: flex;
        justify-content: space-between;
        font-weight: bold;
        color: #409eff;
    }

    .status-true {
        color: green;
    }

    .status-false {
        color: red;
    }

    .approve-actions {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
    }
</style>